export default __webpack_public_path__ + "static/media/map_narthex.b4a76556.png";